import { render, staticRenderFns } from "./PractitionerRenewals.vue?vue&type=template&id=52bf9543&scoped=true&"
import script from "./PractitionerRenewals.vue?vue&type=script&lang=js&"
export * from "./PractitionerRenewals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf9543",
  null
  
)

export default component.exports